import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SkeletonModule } from 'primeng/skeleton';
import { InputSwitchModule } from 'primeng/inputswitch';

import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { AvatarStatusComponent } from './avatar-status/avatar-status.component';
import { AuthImageDirective } from './directives/auth-image.directive';
import { SenhaChecklistComponent } from './senha-checklist/senha-checklist.component';
import { ModalUploadExcelColaboradorComponent } from '../pages/empresa/pages/organograma/components/modais/modal-upload-excel-colaborador/modal-upload-excel-colaborador.component';
import { ViewModeToggleComponent } from './view-mode-toggle/view-mode-toggle.component';
import { MiniTimelineOverlapComponent } from './mini-timeline-overlap/mini-timeline-overlap.component';
import { DeviceBadgeComponent } from './device-badge/device-badge.component';
import { ManagerAgentUnifiedComponent } from './manager-agent-unified/manager-agent-unified.component';
import { SemBaseSuficienteComponent } from './sem-base-suficiente/sem-base-suficiente.component';

@NgModule({
  declarations: [
    HeaderComponent,
    MenuComponent,
    AvatarStatusComponent,
    SenhaChecklistComponent,
    ModalUploadExcelColaboradorComponent,
    ViewModeToggleComponent,
    MiniTimelineOverlapComponent,
    DeviceBadgeComponent,
    ManagerAgentUnifiedComponent,
    SemBaseSuficienteComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TooltipModule,
    DialogModule,
    ButtonModule,
    TableModule,
    ProgressSpinnerModule,
    SkeletonModule,
    InputSwitchModule,
    AuthImageDirective
  ],
  exports: [
    HeaderComponent,
    MenuComponent,
    AvatarStatusComponent,
    AuthImageDirective,
    SenhaChecklistComponent,
    ModalUploadExcelColaboradorComponent,
    ViewModeToggleComponent,
    MiniTimelineOverlapComponent,
    DeviceBadgeComponent,
    ManagerAgentUnifiedComponent,
    SemBaseSuficienteComponent
  ]
})
export class SharedModule {}
